// features/workstations/property-dossier/projection-table.js
// Multi-year cash-flow + equity projection with a cash-flow bar chart.

import { Bars } from './charts';

const money = (n) => '$' + Math.round(Number(n) || 0).toLocaleString();

export default function ProjectionTable({ projection }) {
  if (!projection || !Array.isArray(projection.years) || !projection.years.length) return null;
  const ys = projection.years;
  const bars = ys.map((y) => ({
    label: `Yr ${y.year}${y.saleProceeds > 0 ? ' (sale)' : ''}`,
    value: y.cashFlow + (y.saleProceeds || 0),
  }));
  return (
    <div>
      <div style={{ fontSize: 12, color: '#888', marginBottom: 8 }}>
        IRR <b style={{ color: '#c8a96e' }}>{projection.irrPct == null ? 'n/a' : `${projection.irrPct}%`}</b>
        {' · '}final equity <b style={{ color: '#e8e8ea' }}>{money(projection.finalEquity)}</b>
        {' · '}total profit <b style={{ color: '#7a9e82' }}>{money(projection.totalProfit)}</b>
      </div>
      <Bars data={bars} />
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12, marginTop: 14 }}>
        <thead>
          <tr style={{ color: '#888' }}>
            <th style={{ textAlign: 'left', padding: '6px 8px', borderBottom: '1px solid var(--border-3)' }}>Year</th>
            <th style={{ textAlign: 'right', padding: '6px 8px', borderBottom: '1px solid var(--border-3)' }}>Cash flow</th>
            <th style={{ textAlign: 'right', padding: '6px 8px', borderBottom: '1px solid var(--border-3)' }}>Equity</th>
            <th style={{ textAlign: 'right', padding: '6px 8px', borderBottom: '1px solid var(--border-3)' }}>Cumulative</th>
          </tr>
        </thead>
        <tbody>
          {ys.map((y) => (
            <tr key={y.year}>
              <td style={{ padding: '6px 8px', borderTop: '1px solid var(--border-4)' }}>{y.year}{y.saleProceeds > 0 ? ' (sale)' : ''}</td>
              <td style={{ padding: '6px 8px', borderTop: '1px solid var(--border-4)', textAlign: 'right', color: y.cashFlow >= 0 ? '#7a9e82' : '#c46050' }}>{money(y.cashFlow)}</td>
              <td style={{ padding: '6px 8px', borderTop: '1px solid var(--border-4)', textAlign: 'right' }}>{money(y.equity)}</td>
              <td style={{ padding: '6px 8px', borderTop: '1px solid var(--border-4)', textAlign: 'right' }}>{money(y.cumulative)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
